import {ajaxJSON, isAnyEqualToFirst, isNullOrUndefined} from "../../common/NamaCommon";
import * as urls from "../../constants/NamaURLS";
import * as DomainBaseFieldIDs from "../../constants/DomainBaseFieldIDs";
import * as FieldType from "../../constants/FieldType";
import {currentUserId} from "../../login/LoginPresenter";
import {mapParameters} from "../../actions/BaseDispatcher";
import {toString} from "../../common/FieldTypesUtils";
import {toCSVLineWithSep} from "../../common/StringUtils";
import * as CommonConstants from "../../constants/CommonConstants";
import {createGenericValueForType, getValue} from "../../actions/GenericValues";
import {addDefaultValueQuestions, parameterFieldMap} from "./EmbeddedReportAndDashboardView";
import * as CustomRepLaunchType from "../../constants/CustomRepLaunchType";
import * as places from "../../routing/places";
import {QuestionFieldsSerializer} from "../../common/CriteriaAndQuestionsURLParser";
import {getDirectPrintOption, openUrlInNewWindow, printNext} from "../../common/NaMaPrinting";
import {reportUrl, ReportViewerPresenter} from "../../routing/ReportViewerPresenter";
import * as DownloadPurpose from "../../constants/DownloadPurpose";
import * as OutputFormat from "../../constants/OutputFormat";
import {NamaKendoWindow, NamaWindowBtnData} from "../NamaKendoWindow";
import {EditPresenter} from "../../routing/EditPresenter";
import {ReportLauncherPresenter} from "../../routing/ReportLauncherPresenter";
import {translateNaMaText} from "../../common/Translator";

export class CustomReportLauncherMenuItem {
    /**
     *
     * @param {EditPresenter | ListPresenter} presenter
     * @param {namaTypes.CustomRepInfo} customRepInfo
     */
    constructor(presenter, customRepInfo) {
        let that = this;
        that.id = customRepInfo.reportId;
        that.presenter = presenter;
        that.customRepInfo = customRepInfo;
        that.title = translateNaMaText(customRepInfo.title);
        that.clickFunction = () => that.execute();
    }

    execute() {
        let that = this;
        ajaxJSON(urls.FetchReportMetadata, {
                request: JSON.stringify({
                    id: that.customRepInfo.reportId,
                    entityType: "ReportDefinition",
                    userId: currentUserId()
                })
            }, (result) => {
                that.doExecute(result.data);
            }
        );
    }

    /**
     *
     * @param {namaTypes.ReportMetadataContainer} reportData
     */
    doExecute(reportData) {
        let that = this;
        if (that.presenter.startListView && isAnyEqualToFirst(reportData.report.extraData[DomainBaseFieldIDs.ReportDefinition_reportType],
            "UserForm", "UserList")) {
            that.presenter.printUsing(that.customRepInfo);
            return;
        }
        let parameterValues = {};
        if (that.presenter.startEditView)
            parameterValues = mapParameters(null, -1, that.customRepInfo, that.presenter);
        if (that.presenter.startListView) {
            let objects;
            if (that.customRepInfo.selectedRecordsOnly === true)
                objects = that.presenter.getSelectedObjects();
            else
                objects = that.presenter.getPage_();
            let list = [];
            for (let object of objects) {
                list.push(toString(FieldType.Reference, {id: object}));
            }
            parameterValues["ids"] = createGenericValueForType("ids", toCSVLineWithSep(CommonConstants.LIST_PARAMS_SEP, list), FieldType.Text);
        }
        let parameterMap = parameterFieldMap(that.customRepInfo);
        let questions = [];
        for (let [key, value] of parameterMap) {
            let parameterValue = parameterValues[value];
            if (isNullOrUndefined(parameterValue))
                continue;
            questions.push({
                id: key,
                value: toString(parameterValue.dataType, getValue(parameterValue)),
                objValue: getValue(parameterValue),
            });
        }
        let place = null;
        switch (that.customRepInfo.launchType) {
            case CustomRepLaunchType.DirectInNewPage:
            case CustomRepLaunchType.DirectInPopup:
            case CustomRepLaunchType.Print:
                place = new places.ReportViewerPlace();
                addDefaultValueQuestions(questions, reportData.metadata);
                break;
            case CustomRepLaunchType.ParamsInNewPage:
            case CustomRepLaunchType.ParamsInPopup:
                place = new places.ReportLauncherPlace("");
                break;
        }
        place.questions = new QuestionFieldsSerializer().toURL(questions);
        place.reportId = that.customRepInfo.reportId;
        switch (that.customRepInfo.launchType) {
            case CustomRepLaunchType.DirectInNewPage:
            case CustomRepLaunchType.ParamsInNewPage:
                openUrlInNewWindow(place.fullLink());
                break;
            case CustomRepLaunchType.ParamsInPopup:
            case CustomRepLaunchType.DirectInPopup:
                that.showReportInPopup(place);
                break;
            case CustomRepLaunchType.Print:
                printNext([reportUrl(that.customRepInfo.reportId, "",
                    place.questions, OutputFormat.PDF, getDirectPrintOption(), DownloadPurpose.PRINT)], 0);
                break;
        }
    }

    showReportInPopup(place) {
        let that = this;
        let okBtnData = new NamaWindowBtnData("ok");
        let cancelBtnData = new NamaWindowBtnData("cancel");
        let window = new NamaKendoWindow(that.title, okBtnData, cancelBtnData);
        okBtnData.btnAction = () => window.closeWindow();

        let reportPresenter = new ReportLauncherPresenter(place);
        if (place instanceof places.ReportViewerPlace)
            reportPresenter = new ReportViewerPresenter(place);
        reportPresenter.embeddedReportView = true;
        reportPresenter.reportContainer = window.content;
        reportPresenter.start();
        window.showWindow();
    }

}